<template>
  <div>
    <!-- form starts -->
    <vue-element-loading
      :active="isSubmitted"
      text="MYLE"
      :text-style="loadStyle"
      :is-full-screen="true"
      class="h-full background-overlay"
      spinner="bar-fade-scale"
      color="#ffffff"
    />

    <stripe-checkout
      ref="checkoutRef"
      mode="payment"
      :pk="checkout.publishKey"
      :sessionId="checkout.clientReferenceId"
    />

    <div class="container-fluid p-0" style="overflow-x: hidden">
      <!-- Navbar section starts -->
      <div class="row">
        <div class="col-md-12">
          <nav-bar />
        </div>
      </div>
      <!-- Navbar section ends -->

      <!-- banner section starts -->
      <div class="row text-center">
        <div class="col-md-12" id="banner">
          <img
            class="align-middle imgbottom"
            src="https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/HEADER_BANNER_SAVING.png"
            style="width: 100%; max-width: 100%; height: auto"
          />
        </div>
      </div>
      <!-- banner section ends -->

      <!-- Information -->
      <section id="download" class="white-bg">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-12">
              <div class="mt-4 text-center">
                <h2
                  class="mt-4"
                  style="
                    font-family: 'Quicksand', sans-serif;
                    font-weight: 500;
                    font-size: 26px;
                  "
                >
                  “SAVING OUR CHILDREN”: CONFRONTING THE MENTAL HEALTH CRISIS
                  K-12 EDUCATION. JOIN US FOR THIS IMPORTANT COMMUNITY
                  CONVERSATION TO BRING THE BLACK COMMUNITY TOGETHER TO FOCUS ON
                  THE MENTAL HEALTH OF OUR YOUTH!
                </h2>
              </div>
            </div>
          </div>

          <h6
            class="mb-3 mt-5 text-center"
            style="
              font-family: 'Quicksand', sans-serif;
              font-weight: 700;
              font-size: 28px;
            "
          >
            To attend please
            <a href="#register"> register</a>
            below. <br /><br />
          </h6>

          <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
              <h6
                class="mb-3 font-bold"
                style="
                  font-family: 'Quicksand', sans-serif;
                  font-weight: 500;
                  font-size: 18px;
                "
              >
                WHAT:
                <br />
                “SAVING OUR CHILDREN”
                <br />
                CONFRONTING THE MENTAL HEALTH CRISIS K-12 EDUCATION.
              </h6>
              <br />
              <h6
                class="mb-3 font-bold"
                style="
                  font-family: 'Quicksand', sans-serif;
                  font-weight: 500;
                  font-size: 18px;
                "
              >
                COMMUNITY LEADERS FROM:
                <br />
                FAITH COMMUNITY<br />
                BLACK GIRL ORGANIZATIONS<br />
                BLACK BOYS ORGANIZATIONS<br />
                BLACK YOUTH ORGANIZATION<br />
                FATHERHOOD ORGANIZATIONS<br />
                FRATERNITIES & SORORITIES<br />
                COLUMBUS CITY SCHOOLS<br />
                BEHAVIORAL HEALTH ORGANIZATIONS<br />
              </h6>
              <br />
              <h6
                class="mb-3 font-bold"
                style="
                  font-family: 'Quicksand', sans-serif;
                  font-weight: 500;
                  font-size: 18px;
                "
              >
                WHEN:<br />
                August 10, 2022,<br />
                7:00pm to 8:30pm
                <br /><br />

                WHERE:<br />
                Zoom (link will be provided to registered guest)<br />
                Live Stream -
                <a
                  href="http://columbusblack.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ColumbusBlack.com</a
                >
                <a
                  href="https://www.facebook.com/ColumbusBlackcom-346123302078"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook</a
                >
                or
                <a
                  href="https://www.youtube.com/c/ColumbusBlack/videos"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  YouTube channel</a
                >. <br /><br />

                PRESENTED BY:<br />
                DEWI
                <br /><br />
                SPONSORED BY:<br />
                COLUMBUSBLACK.COM, THINKMAKELIVE, COLUMBUS URBAN LEAGUE
              </h6>
            </div>
          </div>
        </div>
      </section>
      <hr />
      <!-- Information -->

      <!-- Register forms starts -->
      <div id="register">
        <form>
          <div class="container px-5">
            <div class="row">
              <div
                class="col-md-6 d-flex align-items-center justify-content-center"
              >
                <img
                  class="download-img"
                  src="https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/myle_clean_logo.png"
                  style="width: 60%; max-width: 60%; height: auto"
                />
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <h4
                      style="
                        font-family: 'Quicksand', sans-serif;
                        font-weight: 700;
                        font-size: 25px;
                      "
                    >
                      Registration Form
                    </h4>
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-12">
                    <label
                      style="
                        font-family: 'Quicksand', sans-serif;
                        font-weight: 700;
                        font-size: 16px;
                      "
                      >First Name*</label
                    >
                    <input
                      class="form-control"
                      placeholder="Enter your first name"
                      type="text"
                      required
                      v-model="payload.firstName"
                    />
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-12">
                    <label
                      style="
                        font-family: 'Quicksand', sans-serif;
                        font-weight: 700;
                        font-size: 16px;
                      "
                      >Last Name*</label
                    >
                    <input
                      class="form-control"
                      placeholder="Enter your last name"
                      type="text"
                      required
                      v-model="payload.lastName"
                    />
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-12">
                    <label
                      style="
                        font-family: 'Quicksand', sans-serif;
                        font-weight: 700;
                        font-size: 16px;
                      "
                      >Email*</label
                    >
                    <input
                      class="form-control"
                      placeholder="Enter your email address"
                      type="email"
                      required
                      v-model="payload.email"
                    />
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-12">
                    <label
                      style="
                        font-family: 'Quicksand', sans-serif;
                        font-weight: 700;
                        font-size: 16px;
                      "
                      >Have you downloaded or signed up for MYLE?*</label
                    ><br />
                    <input
                      type="radio"
                      name="appdownload"
                      value="1"
                      v-model="payload.appDownload"
                    />
                    Yes
                    <input
                      type="radio"
                      name="appdownload"
                      value="0"
                      v-model="payload.appDownload"
                      class="ml-3"
                    />
                    No
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-12">
                    <input type="checkbox" v-model="payload.receiveEmail" />
                    Yes! I want to receive emails from MYLE to find things to
                    do, places to go and food to eat. I understand I can
                    unsubscribe at anytime
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 text-center my-3">
                    <button
                      type="button"
                      @click="register()"
                      :disabled="
                        !payload.firstName.trim().length ||
                        !payload.lastName.trim().length ||
                        !invalidemail ||
                        isSubmitted
                      "
                      class="btn solid-btn m-auto"
                      style="pointer-events: all; cursor: pointer"
                    >
                      Register
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- Register forms ends -->
    </div>
    <br />
    <div class="row mt-5 w-100 m-0 promo-section MYLE-lite-green">
      <div class="col-lg-12 col-md-12">
        <div class="mt-5">
          <div class="section-heading mb-5">
            <h3 class="text-center text-white">Fun is waiting for you.</h3>
            <h2 class="text-center text-white">Download or Sign-up Today!</h2>
            <div
              class="download-btn mt-4 text-center animate__animated animate__fadeIn"
            >
              <a
                href=" https://apps.apple.com/us/app/myle-create-discover-events-curated-for-you/id1162354481"
                class="btn google-play-btn mr-3"
                target="_blank"
                rel="noopener noreferrer"
                ><span class="ti-apple"></span> App Store</a
              >
              <a
                href="https://play.google.com/store/apps/details?id=xyz.getmyle.myle&hl=en&gl=US"
                class="btn google-play-btn mr-3"
                target="_blank"
                rel="noopener noreferrer"
                ><span class="ti-android"></span> Google Play</a
              >
              <a
                href="https://web.myle.com"
                class="btn google-play-btn"
                target="_blank"
                rel="noopener noreferrer"
                ><span class="ti-world"></span> MYLE Web</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <site-footer :show-subscribe="true" />
  </div>
</template>

<script>
import NavBar from "../../views/commons/NavBar";
import SiteFooter from "../../views/index-five/SiteFooter";
import { StripeCheckout } from "@vue-stripe/vue-stripe";
import axios from "axios";
import VueElementLoading from "vue-element-loading";

export default {
  name: "TrainingComponent",
  components: {
    NavBar,
    SiteFooter,
    VueElementLoading,
    StripeCheckout,
  },
  computed: {
    invalidemail() {
      return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        this.payload.email
      );
    },
  },
  methods: {
    register: function () {
      const payloadToPush = {
        firstName: this.payload.firstName,
        lastName: this.payload.lastName,
        email: this.payload.email.toLowerCase(),
        appDownloaded: Number(this.payload.appDownload),
        subscribed: this.payload.receiveEmail ? 1 : 0,
      };
      const vm = this;
      vm.isSubmitted = true;

      axios
        .post(
          "https://myle-19701.uc.r.appspot.com/api/saving_our_childern_registration_requested",
          payloadToPush
        )
        .then((response) => {
          vm.isSubmitted = false;
          if (
            response.data &&
            response.data.Message &&
            response.data.Status == "Success"
          ) {
            vm.$toast.success(response.data.Message, { timeout: 4000 });
            vm.payload = {
              firstName: "",
              lastName: "",
              email: "",
              appDownload: 1,
              receiveEmail: 1,
            };
          }
        })
        .catch(() => {
          vm.isSubmitted = false;
          vm.$toast.error("Something went wrong", { timeout: 4000 });
        });
    },
  },
  data() {
    return {
      loadStyle: {
        color: "#ffffff",
        "font-weight": "bold",
        "letter-spacing": "1rem",
        "font-size": "18px",
      },
      isSubmitted: false,
      checkout: {
        clientReferenceId: null,
        publishKey:
          "pk_live_51JEQYTD0vTZ4QB9cnmoJMhJQrCybltMAeG2uN3utIarQ342JyZSyyWFXgEdriazLZRFAR1Crne2E1d9PNQFVGxbw00RTp4QVjn",
      },
      payload: {
        firstName: "",
        lastName: "",
        email: "",
        appDownload: 1,
        receiveEmail: true,
      },
      roles: [
        "Convention/Tourism Representative",
        "DJ",
        "Event Goer",
        "Event Planner",
        "Faith Based Representative",
        "Hotel Representative",
        "Influencer",
        "Investor",
        "Lifestyle Critic/Blogger/Writer",
        "Non-Profit Representative",
        "Promoter",
        "Venue Owner",
        "Social Organization Representative",
        "Other",
      ],
      attendees: ["0", "1", "2", "3", "4"],
    };
  },

  metaInfo: {
    title:
      "MYLE | “SAVING OUR CHILDREN”: CONFRONTING THE MENTAL HEALTH CRISIS K-12 EDUCATION",

    meta: [
      {
        name: "description",
        content:
          "“SAVING OUR CHILDREN”: CONFRONTING THE MENTAL HEALTH CRISIS K-12 EDUCATION",
      },

      {
        name: "keywords",
        content:
          "“SAVING OUR CHILDREN”: CONFRONTING THE MENTAL HEALTH CRISIS K-12 EDUCATION",
      },

      {
        name: "copyright",
        content: "MYLE",
      },

      {
        name: "url",
        content:
          "https://myle.com/saving-our-childre-confronting-the-mental-health-crisis-k-12-education",
      },
    ],
  },
};
</script>

<style>
#reserve {
  color: white;
}
#reserve:hover {
  color: #104233;
}
.background-overlay {
  background: #114436c4 !important;
  max-width: 100%;
  z-index: 9999 !important;
}
#banner {
  background-size: cover;
}
</style>
